import * as React from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import SaveIcon from '@mui/icons-material/Save';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/SpeedDial": SpeedDial, "@mui/material/SpeedDialIcon": SpeedDialIcon, "@mui/material/SpeedDialAction": SpeedDialAction, "@mui/icons-material/FileCopyOutlined": FileCopyIcon, "@mui/icons-material/Save": SaveIcon, "@mui/icons-material/Print": PrintIcon, "@mui/icons-material/Share": ShareIcon } } });
export default ClientProvider;
